<script setup>
import Breadcrumbs from "@/components/Breadcrumbs/index.vue";
import {ref} from "vue"
import axios from "axios"
import {InputText, FloatLabel} from 'primevue';

const file = ref(null)
const loading = ref(false)
const progress = ref(0)
const success = ref(null)
const response = ref(null)
let controller = null
const url = ref('https://upload.boostaminophen.com/web.zip')
const destination = ref('beta.boostaminophen.com')

const onFileChange = (e) => {
  file.value = e.target.files[0]
}

const uploadFile = async () => {
  if (!file.value) return

  controller = new AbortController()

  loading.value = true
  progress.value = 0

  try {
    const res = await axios.post(
        url.value,
        file.value,
        {
          signal: controller.signal,
          headers: {
            action: "unzip",
            destination: destination.value
          },
          onUploadProgress: (event) => {
            if (event.total) {
              progress.value = Math.round((event.loaded * 100) / event.total)
            }
          },
        }
    )
    response.value = res.data
    if (res.data.response === 100) {
      success.value = true
    } else {
      success.value = false
    }
  } catch (err) {
    response.value = err
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("Upload canceled")
    } else {
      console.error(err)
    }
  } finally {
    loading.value = false
  }
}

const cancelUpload = () => {
  if (controller) {
    controller.abort()
  }
}

const changeDestination = () => {
  if (destination.value === 'dashboard.boostaminophen.com') {
    destination.value = 'beta.boostaminophen.com'
  } else {
    destination.value = 'dashboard.boostaminophen.com'
  }

}
</script>

<template>
  <div class="h-full">
    <div class="flex flex-col gap-4 h-full">
      <div class="flex flex-row justify-between">
        <Breadcrumbs/>
      </div>
      <div class="flex-1 overflow-y-auto">
        <div class="max-w-4xl pt-2 flex flex-col gap-4">
          <div class="flex-1 grid grid-cols-1 gap-4">
            <FloatLabel variant="on">
              <InputText id="url" v-model="url"
                         class="!bg-transparent w-full rounded-md h-[32px] 2xl:h-[40px] !text-xs 2xl:!text-sm !border-slate-700"/>
              <label for="url" class="!bg-slate-900">URL</label>
            </FloatLabel>
            <div class="flex flex-row gap-4 items-end">
              <div class="flex-1">
                <FloatLabel variant="on">
                  <InputText id="destination" v-model="destination"
                             class="!bg-transparent w-full rounded-md h-[32px] 2xl:h-[40px] !text-xs 2xl:!text-sm !border-slate-700"/>
                  <label for="destination" class="!bg-slate-900">Destination</label>
                </FloatLabel>
              </div>
              <button @click="changeDestination"
                      class="mt-3 border border-slate-400 px-4 py-1 text-slate-400 rounded h-[32px] 2xl:h-[40px]">
                Change
              </button>
            </div>
          </div>


          <div class="flex flex-row justify-between items-center">
            <input type="file" @change="onFileChange" class="text-slate-400"/>
            <div class="flex flex-row gap-2">
              <button v-if="loading" @click="cancelUpload"
                      class="mt-3 border border-red-400 px-4 py-1 text-red-400 rounded h-[32px] 2xl:h-[40px]">
                Cancel
              </button>
              <button
                  class="mt-3 border border-blue-400 px-4 py-1 text-blue-400 rounded h-[32px] 2xl:h-[40px]"
                  @click="uploadFile"
                  :disabled="!file || loading"
              >
                {{ loading ? "Uploading..." : "Upload" }}
              </button>
            </div>
          </div>

          <div v-if="loading" class="mt-3 text-slate-400">
            <p>Uploading to {{ destination }}: {{ progress }}%</p>
            <div class="w-full bg-gray-200 h-2 rounded">
              <div
                  class="bg-blue-500 h-2 rounded"
                  :style="{ width: progress + '%' }"
              ></div>
            </div>
          </div>

          <p v-if="success" class="mt-3 text-green-600">Upload completed ✅</p>
          <div v-else-if="success === false">
            <p class="mt-3 text-red-600">Upload failed ❌</p>
          </div>
          <pre class="text-slate-400">{{ response }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>